import { Route, Routes } from "react-router-dom";
import ClearStorePage from "./pages/ClearStorePage";
import Home from "./pages/Home";
import PVPrint from "./pages/PVPrint";
import PVView from "./pages/PVView";
import VoucherList from "./pages/VoucherList";
import DepartmentsView from "./pages/DepartmentsView";

import styled from 'styled-components';
import PayeesView from "./pages/PayeesView";
import LocationsView from "./pages/LocationsView";
import SectionsView from "./pages/SectionsView";
import BanksView from "./pages/BanksView";
import ProjectsView from "./pages/ProjectsView";

const Container = styled.div`
        border: 1px solid gray;
        border-radius: 5px;
`

const App = () => {
  return (
    <Container>
      <Routes>
        <Route exact path="/" 
                element={<Home />} />
        <Route exact path="/vouchers" 
                element={<VoucherList />} />
        <Route exact path="/vouchers/:voucherId" 
                element={<PVView />} />
        <Route exact path="/vouchers/pfv/:voucherId" 
                element={<PVPrint />} />
        <Route exact path="/clearstore" 
                element={<ClearStorePage />} />
        <Route exact path="/departments" 
                element={<DepartmentsView />} />
        <Route exact path="/departments/:deptId" 
                element={<DepartmentsView />} />
        <Route exact path="/payees" 
                element={<PayeesView />} />
        <Route exact path="/payees/:payeeId" 
                element={<PayeesView />} />
        <Route exact path="/locations" 
                element={<LocationsView />} />
        <Route exact path="/locations/:locationId" 
                element={<LocationsView />} />
        <Route exact path="/sections" 
                element={<SectionsView />} />
        <Route exact path="/sections/:sectionId" 
                element={<SectionsView />} />
        <Route exact path="/banks" 
                element={<BanksView />} />
        <Route exact path="/banks/:bankId" 
                element={<BanksView />} />
        <Route exact path="/projects" 
                element={<ProjectsView />} />
        <Route exact path="/projects/:projectId" 
                element={<ProjectsView />} />
      </Routes>
      </Container>
      
    
  );
}

export default App;
